// extracted by mini-css-extract-plugin
module.exports = {"root":"_dfc1e0","animate":"_2eb11e","cardGradient":"_696c72","title":"_2785e0","subTitle":"_f0da23","usersContainer":"_75f012"};